// Generated by GitHub Copilot

import { Type } from 'class-transformer'
import { Permission } from '#core/entities/auth/roles/Permission.ts'

/** Request payload for `POST /auth/users/` — create a user and assign to the current company. */
export default class UserCreate {
  email: string = ''
  password: string = ''
  first_name: string | null = null
  last_name: string | null = null
  role_id: string | null = null
  @Type(() => Permission)
  personal_permissions: Permission[] | null = null
}
